'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Right;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Right(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      className: 'icon-svg-chevron-right ' + className,
      width: width,
      height: height,
      viewBox: '0 0 28 28' },
    _react2.default.createElement('path', { fill: '#404344', fillRule: 'evenodd', d: 'M22.7207571,6.0918399 L14.812597,14 L22.7207571,21.9081601 C23.093081,22.280484 23.093081,22.8762023 22.7207571,23.2485262 L20.2485262,25.7207571 C19.8762023,26.093081 19.280484,26.093081 18.9081601,25.7207571 L7.8575861,14.6701831 C7.48526218,14.2978591 7.48526218,13.7021409 7.8575861,13.3298169 L18.9081601,2.27924294 C19.280484,1.90691902 19.8762023,1.90691902 20.2485262,2.27924294 L22.7207571,4.75147378 C23.093081,5.1237977 23.093081,5.71951598 22.7207571,6.0918399 Z', transform: 'matrix(-1 0 0 1 30.578 0)' })
  );
}

Right.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Chevron/Right.js
// module id = 154
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14